export const lessThan = (a, b) => {
  return Number(a) < Number(b);
};
